import { useLocation } from "react-router-dom";
import DocumentsTab from "./DocumentsTab";
import DocumentDetail from "./DocumentDetail";
import { useAgencyDocuments } from "./useAgencyDocuments";

const BASE = "/agency/dashboard/documents";

// The Documents tab of the agency dashboard: the list, or one document when
// the URL names it (/agency/dashboard/documents/:id).
const AgencyDocuments: React.FC = () => {
  const location = useLocation();
  const documentId = location.pathname.split(`${BASE}/`)[1]?.split("/")[0] || null;
  return documentId ? <DocumentDetailRoute documentId={documentId} /> : <DocumentsTab />;
};

const DocumentDetailRoute: React.FC<{ documentId: string }> = ({ documentId }) => {
  const { tags, reload } = useAgencyDocuments();
  return <DocumentDetail documentId={documentId} tags={tags} onTagsChanged={reload} />;
};

export default AgencyDocuments;
